import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';

import { PREVIEW_SUBSCRIPTION_DISCOUNT } from '../../mutations';
import ErrorText from '../ErrorText';
import LoadingSpinner from '../LoadingSpinner';
import PromoCodeForm from './PromoCodeForm';
import {
  SET_ERROR_PREVIEW_SUBSCRIPTION_DISCOUNT,
  SET_LOADING_PREVIEW_SUBSCRIPTION_DISCOUNT,
  SET_PROMO_CODE_APPLIED,
  usePurchasePage,
} from '../../hooks/usePurchasePage';
import { isStripePaymentRequired } from '../../utils/featureFlags';

export default function PromoCodeForSubscriptions({ className }) {
  const { state, dispatch } = usePurchasePage();
  const { orderDetails, promoCodeApplied } = state;
  const { recurringInterval, plan } = orderDetails;

  const [promoCode, setPromoCode] = useState();

  const [previewSubscriptionDiscount, { loading, error, data }] = useMutation(
    PREVIEW_SUBSCRIPTION_DISCOUNT
  );

  function handleSubmit(data) {
    if (data.promoCode) {
      setPromoCode(data.promoCode);
    }

    previewSubscriptionDiscount({
      variables: {
        plan,
        recurringInterval,
        promoCode: data.promoCode,
      },
    });
  }

  useEffect(() => {
    if (promoCodeApplied) {
      previewSubscriptionDiscount({
        variables: {
          plan,
          recurringInterval,
          promoCode,
        },
      });
    }
  }, [plan, previewSubscriptionDiscount, promoCode, recurringInterval]);

  useEffect(() => {
    dispatch({
      type: SET_LOADING_PREVIEW_SUBSCRIPTION_DISCOUNT,
      payload: loading,
    });
  }, [dispatch, loading]);

  useEffect(() => {
    dispatch({
      type: SET_ERROR_PREVIEW_SUBSCRIPTION_DISCOUNT,
      payload: error,
    });
  }, [dispatch, error]);

  useEffect(() => {
    if (data?.previewSubscriptionDiscount) {
      const { amount, name } = data.previewSubscriptionDiscount;

      if (amount != null) {
        dispatch({
          type: SET_PROMO_CODE_APPLIED,
          payload: {
            amount,
            name,
            code: promoCode,
          },
        });
      }
    }
  }, [data, dispatch, promoCode]);

  return (
    <>
      {isStripePaymentRequired() && (
        <div className={`flex flex-col ${className ? className : ''}`}>
          {loading && (
            <LoadingSpinner message="Applying promo code..." className="ml-0" />
          )}
          {!loading && (
            <PromoCodeForm
              onSubmit={handleSubmit}
              promoCodeApplied={promoCodeApplied}
            />
          )}
          {error && <ErrorText message={error.message} className="ml-0" />}
        </div>
      )}
    </>
  );
}
